import React from 'react';
import ReactDOM from 'react-dom/client';
import AITrainingMatrix from './AITrainingMatrix';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AITrainingMatrix />);
